import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { PhaseOutput } from '../model/phase.output';

export interface FetchOrganizationPhasesByUserIdParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchOrganizationPhasesByUserIdApiQuery extends ApiQuery<
	PhaseOutput[],
	FetchOrganizationPhasesByUserIdParams
> {
	client = 'content';
	document = gql`
		query FetchOrganizationPhasesByUserId($userId: UUID!) {
			fetchOrganizationPhasesByUserId(userId: $userId) {
				id
				type
				position
				organizationId
				updateTimestamp
				localizations {
					name
					locale
				}
				sections {
					id
					type
					position
					updateTimestamp
					localizations {
						name
						locale
					}
				}
			}
		}
	`;
	method = 'fetchOrganizationPhasesByUserId';
}
